import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Country, ICountry } from "country-state-city";
import {
  CountryList,
  CountrySelectorProps,
} from "../types/CountrySelectorProps";

const CountrySelector: React.FC<CountrySelectorProps> = ({
  onCountryChange,
}) => {
  const [countries, setCountries] = useState<CountryList[]>([]);

  useEffect(() => {
    const countryNamesAndCodes = Country.getAllCountries().map(
      ({ name, isoCode }) => ({
        name,
        isoCode,
      })
    );

    setCountries(countryNamesAndCodes);
  }, []);

  return (
    <Autocomplete
      options={countries}
      getOptionLabel={(option) => option.name}
      size="small"
      renderInput={(params) => <TextField {...params} label="Country" />}
      onChange={(event, selectedCountry) => onCountryChange(selectedCountry)}
    />
  );
};

export default CountrySelector;
